import { render, staticRenderFns } from "./SequencePlateEditor.vue?vue&type=template&id=6db66983&"
import script from "./SequencePlateEditor.vue?vue&type=script&lang=js&"
export * from "./SequencePlateEditor.vue?vue&type=script&lang=js&"
import style0 from "./SequencePlateEditor.vue?vue&type=style&index=0&id=6db66983&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports